/* eslint-disable react/jsx-indent-props */
import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { s3Url } from "../utils/constants";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import MarqueeComponent from "../components/MarqueeComponent";
import { SetSelectedMedia } from "../store/app/appActions";
import HeaderComponent from "../components/HeaderComponent";
import LocationIcon from "../assets/images/location2.svg";
import CalendarIcon from "../assets/images/calendar.svg";
import CloseIcon from "../assets/images/close.svg";
import ArrowRightWhiteIcon from "../assets/images/arrow-right-white.svg";

const Happening = observer(() => {
  const { id } = useParams();
  const { generalStore } = useStores();
  const dispatch = useDispatch();
  useEffect(() => {
    generalStore.activePage = "happening";
    initData();
  }, []);
  const [open, setOpen] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [medias, setMedias] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedPoi, setSelectedPoi] = useState(null);
  const [query, setQuery] = useState("");
  const { allMedia } = useSelector(
    (state) => ({
      allMedia: state.media.medias,
    }),
    shallowEqual,
  );

  useEffect(() => {
    if (id && medias && medias.length > 0) {
      const media = medias.find((media) => media.uniqueId == id);

      if (media) {
        handleSelectMedia(media);
      }
    }
  }, [id, medias, medias.length]);

  function onDismiss() {
    setOpen(false);
    setOpenDetail(false);
    setOpenModal(false);
  }

  const listCategory = [
    "All",
    "Hospital Advisories",
    "New Clinics",
    "Retail-related",
    "All",
    "Hospital Advisories",
    "New Clinics",
    "Retail-related",
  ];

  const toggleCategory = (category) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(
        selectedCategories.filter((cat) => cat !== category),
      );
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  let timeout;

  const handleInputChange = (event) => {
    clearTimeout(timeout); // Clear previous timeout
    const value = event.target.value;
    timeout = setTimeout(() => {
      setQuery(value);
      submitSearch(value);
    }, 300);
  };

  const submitSearch = (q) => {
    let data = allMedia
      .sort((a, b) => {
        return a.name.localeCompare(b.name);
      })
      .filter((e) => {
        return q == ""
          ? true
          : e.name.toLocaleLowerCase().includes(q.toLocaleLowerCase());
      });
    setMedias(data);
  };

  const initData = () => {
    let data = allMedia;
    setMedias(["1", "2"]);
  };
  const navigate = useHistory();

  const handleSelectMedia = (media) => {
    setOpenDetail(true);
    setSelectedMedia(media);
    // const pois = generalStore.pois.filter(
    //   (poi) => poi.client_id == media.associatedPois[0]
    // );
    // if (pois.length > 0) {
    //   setSelectedPoi(pois[0]);
    // } else {
    //   setSelectedPoi(null);
    // }
  };

  const stripHtmlTags = (text) => {
    return "";
    return text.replace(/<\/?[^>]+(>|$)/g, "");
  };

  const handleGoBack = () => {
    if (navigate && navigate.length > 2) {
      navigate.goBack();
    } else {
      navigate.replace("/happening");
    }
  };

  return (
    <Layout>
      <div className="h-full w-full flex flex-col overflow-hidden">
        <HeaderComponent title={"Happenings"} />
        <div className="h-full w-full flex flex-col items-center overflow-hidden bg-whiteBg">
          <div className="h-full w-full grid grid-cols-2 gap-4 p-4 content-start overflow-y-scroll">
            {medias.map((media) => {
              return media.uniqueId ? (
                <Link
                  key={media.id}
                  className="w-full h-auto bg-white rounded-lg"
                  to={`/happening/${media.uniqueId}`}
                >
                  <img
                    src={(() => {
                      try {
                        return media.logo
                          ? `${s3Url}/media/${media.logo}`
                          : require("../assets/images/default.png");
                      } catch (error) {
                        return require("../assets/images/default.png");
                      }
                    })()}
                    className="object-cover aspect-square h-full w-full rounded-t-lg"
                  />
                  <div className="p-3 flex flex-col gap-2">
                    <h2 className="font-medium text-sm text-gray-900 line-clamp-2	">
                      {media.name}
                    </h2>
                    {/* <h3 className="font-light text-sm text-gray-400">
                      CATEGORIES
                    </h3> */}
                    <div className="font-light text-gray-400 line-clamp-3 text-xs">
                      {stripHtmlTags(media.description)}
                    </div>
                  </div>
                </Link>
              ) : (
                <div
                  key={media.id}
                  className="w-full h-auto bg-white rounded-lg cursor-pointer"
                  onClick={() => {
                    handleSelectMedia(media);
                  }}
                >
                  <img
                    src={(() => {
                      try {
                        return media.logo
                          ? `${s3Url}/media/${media.logo}`
                          : require("../assets/images/default.png");
                      } catch (error) {
                        return require("../assets/images/default.png");
                      }
                    })()}
                    className="object-cover aspect-square h-[120px] w-full rounded-t-lg"
                  />
                  <div className="p-3 flex flex-col gap-2">
                    <h2 className="font-medium text-xs text-[#4E4E4E] line-clamp-2	">
                      {media.name ?? "What’s New Title (Max 2 Lines)"}
                    </h2>
                    <div className="flex flex-row gap-1 items-center justify-center">
                      <img
                        src={CalendarIcon}
                        className="object-contain w-3 h-3"
                      />
                      <div className="flex-grow">
                        <span className="text-[#BD553D] font-light text-[8px] line-clamp-1">
                          Start Date - End Date
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-row gap-1 items-center justify-center">
                      <img
                        src={LocationIcon}
                        className="object-contain w-3 h-3"
                      />
                      <div className="flex-grow">
                        <span className="text-[#BD553D] font-light text-[8px] line-clamp-1">
                          Location
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <BottomSheet
        open={open}
        onDismiss={onDismiss}
        snapPoints={({ minHeight }) => minHeight}
        className="rounded-t-lg flex flex-col p-4"
      >
        <div className="flex flex-row justify-between items-center p-4">
          <span>Filter</span>
          <img
            src={require("../assets/images/x.svg")}
            alt=""
            onClick={() => {
              setOpen(false);
            }}
          />
        </div>
        <div className="flex flex-col p-4">
          {listCategory.map((e) => {
            return (
              <div className="flex items-center  mb-4" key={e + "dd"}>
                <input
                  id={e}
                  type="checkbox"
                  value="true"
                  checked={selectedCategories.includes(e)}
                  onChange={() => toggleCategory(e)}
                  className="w-5 h-5 appearance-none border cursor-pointer border-gray-300  rounded-md mr-2 checked:bg-no-repeat checked:bg-center checked:bg-checked"
                />
                <label
                  for={e}
                  className="text-sm font-norma cursor-pointer text-gray-600"
                >
                  {selectedCategories.includes(e)}
                  {e}
                </label>
              </div>
            );
          })}
          <button className="bg-bgColor text-white font-bold py-3 px-4 rounded-full mt-4">
            Apply Filter
          </button>
        </div>
      </BottomSheet>

      {selectedMedia && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex rounded-lg justify-center items-center z-[90]">
          <div className="bg-white rounded-xl shadow-lg w-96">
            <div className="flex flex-col gap-4">
              <div className="relative">
                <img
                  src={(() => {
                    try {
                      return selectedMedia.logo
                        ? `${s3Url}/media/${selectedMedia.logo}`
                        : require("../assets/images/default.png");
                    } catch (error) {
                      return require("../assets/images/default.png");
                    }
                  })()}
                  className="w-full rounded-t-lg"
                />
                <div className="absolute top-0 right-0 p-2">
                  <img
                    className="h-6 w-6"
                    src={CloseIcon}
                    onClick={() => {
                      setSelectedMedia(null);
                    }}
                  />
                </div>
              </div>

              <div className="px-4 pb-4 flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <span className="text-xs text-[#40403F] line-clamp-1">
                    What New Title
                  </span>
                  <div className="flex flex-row gap-1 items-center justify-center">
                    <img
                      src={CalendarIcon}
                      className="object-contain w-3 h-3"
                    />
                    <div className="flex-grow">
                      <span className="text-[#BD553D] font-light text-[8px] line-clamp-1">
                        Start Date - End Date
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-row gap-1 items-center justify-center">
                    <img
                      src={LocationIcon}
                      className="object-contain w-3 h-3"
                    />
                    <div className="flex-grow">
                      <span className="text-[#BD553D] font-light text-[8px] line-clamp-1">
                        Location
                      </span>
                    </div>
                  </div>
                </div>
                <div className="pt-4">
                  <div
                    className="flex items-center justify-center p-3 bg-[#12529C] text-[#FFFFFF] border-[rgba(18, 82, 156, 0.12)] rounded-full "
                    onClick={() => {}}
                  >
                    Get Direction&nbsp;
                    <img className="w-5 h-5" src={ArrowRightWhiteIcon} />
                  </div>
                </div>
              </div>
            </div>
            {openModal && (
              <div className="w-full h-full fixed top-0 r-0 z-50 bg-[#00000066] flex flex-col items-center justify-center p-4">
                <div className="flex flex-col bg-white w-full rounded-lg p-4 gap-4">
                  <div className="flex flex-row justify-end">
                    <img
                      src={require("../assets/images/x.svg")}
                      alt=""
                      onClick={() => {
                        setOpenModal(false);
                      }}
                    />
                  </div>
                  <div className="flex flex-row justify-between gap-4">
                    <div className="flex flex-col gap-2 items-center justify-center px-4 py-8 bg-[#FCF4EB] rounded-lg w-full">
                      <img
                        src={require("../assets/images/stair.svg")}
                        className="aspect-square w-20 h-20"
                      />
                      <span className="font-bold text-sm text-gray-500">
                        Staircase Access
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 items-center justify-center px-4 py-8 bg-[#FCF4EB] rounded-lg w-full">
                      <img
                        src={require("../assets/images/lift.svg")}
                        className="aspect-square w-20 h-20"
                      />
                      <span className="font-bold text-sm text-gray-500">
                        Lift Access
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
});

export default Happening;
